/**
 *
 * @param {string} elementClass
 * Horizontal scroll function. Added grab cursor, hide scrollbar etc.
 */
export const horizontalScroll = ( elementClass ) => {

	document.addEventListener( 'DOMContentLoaded', () => {


		const element = document.querySelector( elementClass );

		if ( element ) {

			element.style.cursor = 'grab';

			let pos = { top: 0, left: 0, x: 0, y: 0 };

			/**
			 * Checks if the element is scrollable by comparing the scrollWidth with the offsetWidth.
			 * If the element is scrollable, it adds the 'is-scrollable' class, otherwise it removes the class.
			 * @function checkIfScrollable
			 */
			const checkIfScrollable = () => {

				if( element.scrollWidth > element.offsetWidth ){

					element.classList.add( 'is-scrollable' );

				}
				else{

					element.classList.remove( 'is-scrollable' );

				}

			}

			/**
			 * Mouse down handler function
			 *
			 * @param {Event} e
			 */
			const mouseDownHandler = ( e ) => {

				element.style.cursor = 'grabbing';
				element.style.userSelect = 'none';

				if ( e.target.tagName === 'A' ) {

					e.preventDefault();

				}

				pos = {
					left: element.scrollLeft,
					top: element.scrollTop,
					x: e.clientX,
					y: e.clientY,
				};

				document.addEventListener( 'mousemove', mouseMoveHandler );
				document.addEventListener( 'mouseup', mouseUpHandler );

			};

			/**
			 * Mouse move handler function
			 *
			 * @param {Event} e
			 */
			const mouseMoveHandler = ( e ) => {

				// How far the mouse has been moved
				const dx = e.clientX - pos.x;

				element.scrollLeft = pos.left - dx;

			};

			/**
			 * Event on mouseUp
			 */
			const mouseUpHandler = () => {

				element.style.cursor = 'grab';
				element.style.removeProperty( 'user-select' );

				document.removeEventListener( 'mousemove', mouseMoveHandler );
				document.removeEventListener( 'mouseup', mouseUpHandler );

			};

			// Attach the handler
			element.addEventListener( 'mousedown', mouseDownHandler );
			checkIfScrollable()
			window.addEventListener( 'resize', checkIfScrollable );


		}

	} );

};
